import { Link } from 'react-router-dom'

/** Terms of use for getduva.com — expand with counsel before enterprise contracts. */
export function TermsPage() {
  return (
    <div className="min-h-screen" style={{ background: '#F5F2EA' }}>
      <div className="max-w-xl mx-auto px-4 py-10">
        <Link
          to="/login"
          className="text-xs mb-8 inline-block transition-colors"
          style={{ color: '#9aafb3' }}
        >
          ← Back to sign in
        </Link>

        <header className="mb-10">
          <div className="text-3xl mb-2">🕊</div>
          <h1
            className="text-2xl font-bold tracking-tight"
            style={{ color: '#1a3a40', fontFamily: 'Georgia, serif' }}
          >
            Terms of use
          </h1>
          <p className="text-sm mt-2" style={{ color: '#3d6068' }}>
            Last updated: August 2026 · Questions:{' '}
            <a href="mailto:support@getduva.com" style={{ color: '#2A7A8A' }}>
              support@getduva.com
            </a>
          </p>
        </header>

        <div
          className="rounded-2xl p-8 space-y-6"
          style={{
            background: '#FDFCF8',
            border: '1px solid #e0d9cc',
            boxShadow: '0 2px 16px rgba(42,122,138,0.07)',
          }}
        >
          <section>
            <h2 className="text-sm font-semibold mb-2" style={{ color: '#1a3a40' }}>
              The service
            </h2>
            <p className="text-sm leading-relaxed" style={{ color: '#3d6068' }}>
              Duva provides behavioral nudges and related workplace tools through Slack, Microsoft Teams,
              email, and the web dashboard at getduva.com. By installing or using Duva, your organization
              agrees to these terms on behalf of its users.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-2" style={{ color: '#1a3a40' }}>
              Acceptable use
            </h2>
            <p className="text-sm leading-relaxed" style={{ color: '#3d6068' }}>
              You will use Duva only for lawful internal workplace purposes. Do not attempt to access other
              organizations&apos; data, reverse engineer the service, or use it to harass or surveil individuals
              beyond what your organization&apos;s policies allow.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-2" style={{ color: '#1a3a40' }}>
              Plans &amp; billing
            </h2>
            <p className="text-sm leading-relaxed" style={{ color: '#3d6068' }}>
              Free and paid tiers may have seat or feature limits as described on the pricing page. Paid plans
              are subject to the order form or invoice agreed with Duva. We may change features or pricing with
              reasonable notice where required by law.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-2" style={{ color: '#1a3a40' }}>
              Data &amp; privacy
            </h2>
            <p className="text-sm leading-relaxed" style={{ color: '#3d6068' }}>
              Our handling of personal data is described in the{' '}
              <Link to="/privacy" className="underline underline-offset-2" style={{ color: '#2A7A8A' }}>
                Privacy Policy
              </Link>
              . Enterprise customers may request a data processing agreement.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-2" style={{ color: '#1a3a40' }}>
              Disclaimer
            </h2>
            <p className="text-sm leading-relaxed" style={{ color: '#3d6068' }}>
              Duva nudges are informational prompts based on behavioral science research. They are not medical,
              legal, or HR advice. The service is provided &quot;as is&quot; to the extent permitted by law.
            </p>
          </section>

          <p className="text-xs pt-4 border-t" style={{ color: '#9aafb3', borderColor: '#e0d9cc' }}>
            This is a working summary for self-serve customers. Enterprise agreements may supersede these terms.
            See also{' '}
            <Link to="/security" className="underline underline-offset-2" style={{ color: '#2A7A8A' }}>
              Security
            </Link>
            .
          </p>
        </div>
      </div>
    </div>
  )
}
